module.exports = __webpack_public_path__ + "static/images/containers/MainMenu/images/mainmenu-item-boost-64-active.3a1f36dd.png";


//////////////////
// WEBPACK FOOTER
// ./containers/MainMenu/images/mainmenu-item-boost-64-active.png
// module id = 3190
// module chunks = 11